// ------- CaretDown-Icon ------- //
export const CaretDownIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8421 8.33333L10.6755 12.5L6.50879 8.33333"
        stroke="#222222"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// ------- Serch-Icon ------- //
export const SerchIcon = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      width="15"
      height="15"
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1993_12424)">
        <path
          d="M19.7552 18.5768L14.781 13.6027C16.1365 11.9448 16.803 9.82941 16.6425 7.69396C16.4821 5.55852 15.507 3.56644 13.919 2.12976C12.331 0.693089 10.2515 -0.0782598 8.1107 -0.0247333C5.96991 0.0287933 3.93158 0.903099 2.41734 2.41734C0.903099 3.93158 0.0287933 5.96991 -0.0247333 8.1107C-0.0782598 10.2515 0.693089 12.331 2.12976 13.919C3.56644 15.507 5.55852 16.4821 7.69396 16.6425C9.82941 16.803 11.9448 16.1365 13.6027 14.781L18.5768 19.7552C18.734 19.907 18.9445 19.991 19.163 19.9891C19.3815 19.9872 19.5905 19.8995 19.745 19.745C19.8995 19.5905 19.9872 19.3815 19.9891 19.163C19.991 18.9445 19.907 18.734 19.7552 18.5768ZM8.33266 14.9993C7.01412 14.9993 5.72519 14.6083 4.62886 13.8758C3.53253 13.1433 2.67805 12.1021 2.17347 10.8839C1.66888 9.66571 1.53686 8.32527 1.79409 7.03206C2.05133 5.73885 2.68627 4.55097 3.61862 3.61862C4.55097 2.68627 5.73885 2.05133 7.03206 1.79409C8.32527 1.53686 9.66571 1.66888 10.8839 2.17347C12.1021 2.67805 13.1433 3.53253 13.8758 4.62886C14.6083 5.72519 14.9993 7.01412 14.9993 8.33266C14.9973 10.1002 14.2943 11.7947 13.0445 13.0445C11.7947 14.2943 10.1002 14.9973 8.33266 14.9993Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1993_12424">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- User-Icon ------- //
export const UserIcon = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      width="18"
      height="18"
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1993_12431)">
        <path
          d="M17.5 20.0003H15.8333V15.7978C15.8327 15.1445 15.5728 14.5181 15.1109 14.0561C14.6489 13.5942 14.0225 13.3343 13.3692 13.3337H6.63083C5.9775 13.3343 5.35111 13.5942 4.88914 14.0561C4.42716 14.5181 4.16733 15.1445 4.16667 15.7978V20.0003H2.5V15.7978C2.50132 14.7027 2.93696 13.6527 3.71135 12.8783C4.48575 12.104 5.53567 11.6683 6.63083 11.667H13.3692C14.4643 11.6683 15.5143 12.104 16.2886 12.8783C17.063 13.6527 17.4987 14.7027 17.5 15.7978V20.0003Z"
          fill="#4E4E4E"
        />
        <path
          d="M10 10C9.0111 10 8.0444 9.70676 7.22215 9.15735C6.39991 8.60794 5.75904 7.82705 5.3806 6.91342C5.00217 5.99979 4.90315 4.99446 5.09608 4.02455C5.289 3.05465 5.76521 2.16373 6.46447 1.46447C7.16373 0.765206 8.05465 0.289002 9.02455 0.0960758C9.99446 -0.0968503 10.9998 0.00216643 11.9134 0.380605C12.8271 0.759043 13.6079 1.39991 14.1574 2.22215C14.7068 3.0444 15 4.0111 15 5C14.9987 6.32568 14.4715 7.59668 13.5341 8.53407C12.5967 9.47147 11.3257 9.99868 10 10ZM10 1.66667C9.34073 1.66667 8.69627 1.86217 8.1481 2.22844C7.59994 2.59471 7.1727 3.1153 6.9204 3.72439C6.66811 4.33348 6.6021 5.0037 6.73072 5.6503C6.85934 6.29691 7.1768 6.89085 7.64298 7.35703C8.10915 7.8232 8.7031 8.14067 9.3497 8.26929C9.9963 8.3979 10.6665 8.33189 11.2756 8.0796C11.8847 7.82731 12.4053 7.40007 12.7716 6.8519C13.1378 6.30374 13.3333 5.65927 13.3333 5C13.3333 4.11595 12.9821 3.2681 12.357 2.64298C11.7319 2.01786 10.8841 1.66667 10 1.66667Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1993_12431">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- Trolly-Icon ------- //
export const TrollyIcon = ({ className }) => {
  return (
    <svg
      width="18"
      height="18"
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1993_12436)">
        <g clipPath="url(#clip1_1993_12436)">
          <path
            d="M18.9275 3.3975C18.6931 3.1162 18.3996 2.88996 18.0679 2.73485C17.7363 2.57973 17.3745 2.49955 17.0083 2.5H3.535L3.5 2.2075C3.42837 1.59951 3.13615 1.03894 2.67874 0.632065C2.22133 0.225186 1.63052 0.000284828 1.01833 0L0.833333 0C0.61232 0 0.400358 0.0877974 0.244078 0.244078C0.0877974 0.400358 0 0.61232 0 0.833333C0 1.05435 0.0877974 1.26631 0.244078 1.42259C0.400358 1.57887 0.61232 1.66667 0.833333 1.66667H1.01833C1.22244 1.66669 1.41945 1.74163 1.57198 1.87726C1.72451 2.0129 1.82195 2.19979 1.84583 2.4025L2.9925 12.1525C3.11154 13.1665 3.59873 14.1015 4.36159 14.78C5.12445 15.4585 6.10988 15.8334 7.13083 15.8333H15.8333C16.0543 15.8333 16.2663 15.7455 16.4226 15.5893C16.5789 15.433 16.6667 15.221 16.6667 15C16.6667 14.779 16.5789 14.567 16.4226 14.4107C16.2663 14.2545 16.0543 14.1667 15.8333 14.1667H7.13083C6.61505 14.1652 6.11233 14.0043 5.69161 13.7059C5.27089 13.4075 4.95276 12.9863 4.78083 12.5H14.7142C15.6911 12.5001 16.6369 12.1569 17.3865 11.5304C18.1361 10.9039 18.6417 10.0339 18.815 9.0725L19.4692 5.44417C19.5345 5.08417 19.5198 4.71422 19.4262 4.36053C19.3326 4.00684 19.1623 3.67806 18.9275 3.3975ZM17.8333 5.14833L17.1783 8.77667C17.0743 9.35417 16.7704 9.87666 16.3199 10.2527C15.8694 10.6287 15.301 10.8342 14.7142 10.8333H4.51583L3.73167 4.16667H17.0083C17.1307 4.16594 17.2518 4.19218 17.3629 4.24355C17.4741 4.29491 17.5725 4.37012 17.6513 4.46384C17.73 4.55756 17.7872 4.66748 17.8186 4.78578C17.8501 4.90409 17.8551 5.02787 17.8333 5.14833Z"
            fill="#4E4E4E"
          />
          <path
            d="M5.83268 19.9993C6.75316 19.9993 7.49935 19.2532 7.49935 18.3327C7.49935 17.4122 6.75316 16.666 5.83268 16.666C4.91221 16.666 4.16602 17.4122 4.16602 18.3327C4.16602 19.2532 4.91221 19.9993 5.83268 19.9993Z"
            fill="#4E4E4E"
          />
          <path
            d="M14.1667 19.9993C15.0871 19.9993 15.8333 19.2532 15.8333 18.3327C15.8333 17.4122 15.0871 16.666 14.1667 16.666C13.2462 16.666 12.5 17.4122 12.5 18.3327C12.5 19.2532 13.2462 19.9993 14.1667 19.9993Z"
            fill="#4E4E4E"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1993_12436">
          <rect width="20" height="20" fill="white" />
        </clipPath>
        <clipPath id="clip1_1993_12436">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- Heart-Icon ------- //
export const HeartIcon = ({ className, onClick }) => {
  return (
    <svg
      width="18"
      height="18"
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1993_12442)">
        <path
          d="M14.5776 0.763672C13.6396 0.778262 12.722 1.0401 11.9176 1.52276C11.1132 2.00541 10.4504 2.69178 9.99609 3.51256C9.54181 2.69178 8.87899 2.00541 8.07457 1.52276C7.27014 1.0401 6.35261 0.778262 5.41461 0.763672C3.91933 0.828638 2.51054 1.48276 1.49601 2.58313C0.481482 3.6835 -0.0563096 5.14068 0.000126376 6.6363C0.000126376 12.2799 9.12644 18.7981 9.51462 19.0746L9.99609 19.4153L10.4776 19.0746C10.8657 18.7997 19.9921 12.2799 19.9921 6.6363C20.0485 5.14068 19.5107 3.6835 18.4962 2.58313C17.4817 1.48276 16.0729 0.828638 14.5776 0.763672ZM9.99609 17.3645C7.28635 15.3403 1.66612 10.3673 1.66612 6.6363C1.60918 5.58232 1.9713 4.54859 2.67352 3.76055C3.37573 2.97251 4.36106 2.4941 5.41461 2.42967C6.46816 2.4941 7.45349 2.97251 8.1557 3.76055C8.85791 4.54859 9.22004 5.58232 9.1631 6.6363H10.8291C10.7721 5.58232 11.1343 4.54859 11.8365 3.76055C12.5387 2.97251 13.524 2.4941 14.5776 2.42967C15.6311 2.4941 16.6165 2.97251 17.3187 3.76055C18.0209 4.54859 18.383 5.58232 18.3261 6.6363C18.3261 10.369 12.7058 15.3403 9.99609 17.3645Z"
          fill="#4E4E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1993_12442">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};


// ------- User01-Icon ------- //
export const User01Icon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z"
        stroke="#A7A7A7"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
        stroke="#A7A7A7"
        strokeWidth="1.7"
      />
    </svg>
  );
};

// ------- Order-Icon ------- //
export const OrderIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11C3 7.25027 3 5.3754 3.95491 4.06107C4.26331 3.6366 4.6366 3.26331 5.06107 2.95491C6.3754 2 8.25027 2 12 2C15.7497 2 17.6246 2 18.9389 2.95491C19.3634 3.26331 19.7367 3.6366 20.0451 4.06107C21 5.3754 21 7.25027 21 11V13C21 16.7497 21 18.6246 20.0451 19.9389C19.7367 20.3634 19.3634 20.7367 18.9389 21.0451C17.6246 22 15.7497 22 12 22C8.25027 22 6.3754 22 5.06107 21.0451C4.6366 20.7367 4.26331 20.3634 3.95491 19.9389C3 18.6246 3 16.7497 3 13V11Z"
        stroke="#A7A7A7"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9.5H7M10 14.5H7"
        stroke="#A7A7A7"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// ------- Heart01-Icon ------- //
export const Heart01Icon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4626 3.99415C16.7809 2.34923 14.4404 3.01211 13.0344 4.06801C12.4578 4.50096 12.1696 4.71743 12 4.71743C11.8304 4.71743 11.5422 4.50096 10.9656 4.06801C9.55962 3.01211 7.21909 2.34923 4.53744 3.99415C1.01807 6.15294 0.22172 13.2749 8.33953 19.2834C9.88572 20.4278 10.6588 21 12 21C13.3412 21 14.1143 20.4278 15.6605 19.2834C23.7783 13.2749 22.9819 6.15294 19.4626 3.99415Z"
        stroke="#A7A7A7"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
};

// ------- Faq-Icon ------- //
export const FAQIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#A7A7A7"
        strokeWidth="1.7"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path d="M12 16.5H12.009" stroke="#A7A7A7" />
      <path
        d="M12 16.5H12.009"
        stroke="#A7A7A7"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5C14 9.89815 13.8837 10.2691 13.6831 10.5808C13.0854 11.5097 12 12.3954 12 13.5"
        stroke="#A7A7A7"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
};

// ------- Logout-Icon ------- //
export const LogoutIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 17.625C14.9264 19.4769 13.3831 21.0494 11.3156 20.9988C10.8346 20.987 10.2401 20.8194 9.05112 20.484C6.18961 19.6768 3.70555 18.3203 3.10956 15.2815C3 14.723 3 14.0944 3 12.8373V11.1627C3 9.90561 3 9.27705 3.10956 8.71846C3.70555 5.67965 6.18961 4.32316 9.05112 3.51603C10.2401 3.18064 10.8346 3.01295 11.3156 3.00119C13.3831 2.95061 14.9264 4.52307 15 6.37501"
        stroke="#A7A7A7"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M21 12H10M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
        stroke="#A7A7A7"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// ------- Bar-Icon ------- //
export const BarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="28"
      height="28"
      color="#4E4E4E"
      fill="none"
    >
      <path
        d="M4 5L16 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12L20 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 19L12 19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
